import React from 'react';
import { Paper, Stack, Typography, Chip, Divider } from '@mui/material';
import { AppChip } from '../../StyledComponent';
import { getStatusColor } from '../../../utils/helpers';

const CustomerInfoBar = ({
  customerId,
  customerDetails,
  isClasiified,
  emailCustomerDetails,
  month,
  year,
  emailData,
  customerTask,
}) => (
  <Paper
    elevation={1}
    sx={{
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      p: 2,
      borderRadius: 2,
      gap: 1,
      overflow: 'auto',
    }}
  >
    {!!customerId ? (
      <>
        <Stack flexDirection={'column'}>
          <Typography variant="body2">Customer/Family Name:</Typography>
          <Typography variant="body1">
            {customerDetails?.familyName}{' '}
          </Typography>
        </Stack>
        <Chip
          size="small"
          label={customerDetails?.status}
          color={getStatusColor(!customerDetails?.readOnly)}
        />
      </>
    ) : (
      <Typography variant="h5" color={isClasiified ? '#2400FF' : 'red'}>
        {isClasiified ? 'Multiple Client' : 'Unclassified'}
      </Typography>
    )}
    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
    <Stack flexDirection={'column'}>
      <Typography variant="body2">Email ID:</Typography>
      <Typography variant="body1">
        {emailCustomerDetails?.customerEmail}
      </Typography>
    </Stack>
    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
    <AppChip
      fontSize="0.9rem"
      backgroundColor={'#BE897626'}
      label={`No.of Files - ${emailData?.documentCount}`}
    />
    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
    <Stack flexDirection={'column'}>
      <Typography variant="body2">Received Month / Year:</Typography>
      <Typography variant="body1">
        {month} / {year}
      </Typography>
    </Stack>
    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
    {!!customerId && customerTask?.timelineStatus ? (
      <AppChip
        fontSize="0.9rem"
        backgroundColor={'#BE897626'}
        label={`Task Status - ${customerTask?.timelineStatus}`}
      />
    ) : (
      'No Task Found'
    )}
  </Paper>
);

export default CustomerInfoBar; 